var TABLE_ITEM_CLICK = 'TABLE_ITEM_CLICK';
var TABLE_ITEM_SELECT = 'TABLE_ITEM_SELECT';
var TABLE_ITEMS_PAGE_UPDATE = 'TABLE_ITEMS_PAGE_UPDATE';
var TABLE_ITEMS_SET_FILTER = 'TABLE_ITEMS_SET_FILTER';
var TABLE_ITEMS_SET_SORT = 'TABLE_ITEMS_SET_SORT';
var TABLE_ITEMS_FETCH = 'TABLE_ITEMS_FETCH';
var TABLE_ITEMS_FETCH_WITH_FILTER_AND_SORT_PREFERENCES = 'TABLE_ITEMS_FETCH_WITH_FILTER_AND_SORT_PREFERENCES';
var TABLE_SEARCH = 'TABLE_SEARCH';
var TABLE_SEARCH_TERM_UPDATE = 'TABLE_SEARCH_TERM_UPDATE';
var CLEAR = 'CLEAR';
var VIEW_PDF = 'VIEW_PDF';
var TABLE_ITEMS_SORT = 'TABLE_ITEMS_SORT';
var TABLE_SCROLL_FETCH = 'TABLE_SCROLL_FETCH';
var TABLE_ITEMS_ON_PIVOT_GROUP = 'TABLE_ITEMS_ON_PIVOT_GROUP';
var TABLE_ITEMS_REFRESH = 'TABLE_ITEMS_REFRESH';
var TABLE_SEARCH_FIELD = 'TABLE_SEARCH_FIELD';
var MULTI_SORT = 'MULTI_SORT';
export default {
  TABLE_ITEM_CLICK: TABLE_ITEM_CLICK,
  TABLE_ITEM_SELECT: TABLE_ITEM_SELECT,
  TABLE_ITEMS_PAGE_UPDATE: TABLE_ITEMS_PAGE_UPDATE,
  TABLE_ITEMS_SET_FILTER: TABLE_ITEMS_SET_FILTER,
  TABLE_ITEMS_FETCH: TABLE_ITEMS_FETCH,
  TABLE_SEARCH: TABLE_SEARCH,
  TABLE_SEARCH_TERM_UPDATE: TABLE_SEARCH_TERM_UPDATE,
  CLEAR: CLEAR,
  VIEW_PDF: VIEW_PDF,
  TABLE_ITEMS_SORT: TABLE_ITEMS_SORT,
  MULTI_SORT: MULTI_SORT,
  TABLE_SCROLL_FETCH: TABLE_SCROLL_FETCH,
  TABLE_ITEMS_FETCH_WITH_FILTER_AND_SORT_PREFERENCES: TABLE_ITEMS_FETCH_WITH_FILTER_AND_SORT_PREFERENCES,
  TABLE_ITEMS_ON_PIVOT_GROUP: TABLE_ITEMS_ON_PIVOT_GROUP,
  TABLE_ITEMS_REFRESH: TABLE_ITEMS_REFRESH,
  TABLE_SEARCH_FIELD: TABLE_SEARCH_FIELD,
  TABLE_ITEMS_SET_SORT: TABLE_ITEMS_SET_SORT
};